/**
 * Country Switcher
 * Handles country selection and sets cookies
 */
(function ($) {
    'use strict';

    // Map country to language
    const mapCountryToLanguage = function (countryCode) {
        const map = {
            'netherlands': 'nl',
            'germany': 'de',
            'switzerland': 'de',
            'spain': 'es',
            'france': 'fr',
            'italy': 'it',
            'uk': 'en',
            'global': 'en'
        };
        return map[countryCode?.toLowerCase()] || 'en';
    };

    // Map country/language to flag URL (hardcoded for reliability)
    const getFlagUrl = function (countryOrLanguage) {
        const code = (countryOrLanguage || '').toLowerCase();
        const baseUrl = '/wp-content/plugins/sitepress-multilingual-cms/res/flags/';

        const flagMap = {
            'nl': baseUrl + 'nl.png',
            'netherlands': baseUrl + 'nl.png',
            'de': baseUrl + 'de.png',
            'germany': baseUrl + 'de.png',
            'ch': baseUrl + 'ch.png',
            'switzerland': baseUrl + 'ch.png',
            'es': baseUrl + 'es.png',
            'spain': baseUrl + 'es.png',
            'en': baseUrl + 'en.png',
            'uk': baseUrl + 'en.png',
            'fr': baseUrl + 'fr.png',
            'france': baseUrl + 'fr.png',
            'it': baseUrl + 'it.png',
            'italy': baseUrl + 'it.png',
            'global': null // Will use SVG globe
        };

        return flagMap[code] || null;
    };

    // Set cookie client-side
    const setCookie = function (name, value, days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        const expires = 'expires=' + date.toUTCString();
        document.cookie = name + '=' + value + ';' + expires + ';path=/;secure;samesite=Lax';
    };

    // Handle country switcher links
    $(document).on('click', '.country-switcher-link', function (e) {
        e.preventDefault();

        const countrySlug = $(this).data('country');
        const postId = $(this).data('post-id') || 0;

        if (!countrySlug) {
            return;
        }

        // Map country to language for the event
        const language = mapCountryToLanguage(countrySlug);

        // Get flag URL from hardcoded mapping (more reliable than DOM extraction)
        const flagUrl = getFlagUrl(countrySlug);

        // Set cookies CLIENT-SIDE immediately (don't wait for AJAX)
        setCookie('era_country_pref', countrySlug, 365);
        setCookie('wp-wpml_current_language', language, 365);
        // Store flag URL in cookie so it's available on page load
        if (flagUrl) {
            setCookie('eraneos_flag_url', flagUrl, 365);
        } else {
            // Global option - store 'global' so we know to show globe
            setCookie('eraneos_flag_url', 'global', 365);
        }

        // Fire custom event for immediate UI updates
        try {
            const event = new CustomEvent('countryPreferenceChanged', {
                detail: { country: countrySlug, language: language, flagUrl: flagUrl }
            });
            document.dispatchEvent(event);
        } catch (_) {
            // noop
        }

        // Send AJAX request to set cookie (for server-side sync) when localized by PHP.
        if (typeof countrySwitcherData !== 'undefined') {
            $.ajax({
                url: countrySwitcherData.ajaxurl,
                type: 'POST',
                data: {
                    action: 'set_country_preference',
                    country: countrySlug,
                    post_id: postId,
                    nonce: countrySwitcherData.nonce
                },
                success: function (response) {
                    console.log(response);
                    if (response.success && response.data.redirect) {
                        // Small delay to ensure cookies are written before redirect
                        setTimeout(function () {
                            window.location.href = response.data.redirect;
                        }, 100);
                    }
                }
            });
        }
    });

})(jQuery); 